import { Button } from "../../../components/Button";
import { Card } from "../../../components/Card";
import { Body, Heading, Kicker } from "../../../components/Typography";
import { Section } from "../DesignSystem";

const grid: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  gap: "var(--space-6)",
};

export const CardsSection = () => (
  <Section label="07 · Components" title="Cards">
    <div style={grid}>
      <Card variant="plain">
        <Kicker>Privacy first</Kicker>
        <Heading level={3}>Offline-capable, user-controlled AI</Heading>
        <Body>Your data stays on your hardware — no ad business, no data marketplace.</Body>
      </Card>
      <Card variant="gradient">
        <Kicker>Opened a new shop?</Kicker>
        <Heading level={3}>Add a store in under five minutes.</Heading>
        <Button variant="outline" style={{ marginTop: "var(--space-4)" }}>
          Start setup
        </Button>
      </Card>
    </div>
  </Section>
);
